import { render } from "./TMultiselectTree.vue?vue&type=template&id=5ca5619c&scoped=true"
import script from "./TMultiselectTree.vue?vue&type=script&lang=js"
export * from "./TMultiselectTree.vue?vue&type=script&lang=js"

import "./TMultiselectTree.vue?vue&type=style&index=0&id=5ca5619c&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca5619c"]])

export default __exports__